import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Autocomplete } from '@mui/material';

import Input from '../../../form/Input';
import TextArea from '../../../form/TextArea';
import Checkbox from '../../../form/Checkbox';
import Select from '../../../form/Select';

import * as SituacaoAPI from '../../../../api/situacao';
import * as UsuarioAPI from '../../../../api/usuario';

function HomologationPessoaDialog({ open, onClose, onSave, formData, pessoaId, empresaId, empresaIds, empresaTabelaId }) {
    const [dados, setDados] = useState({});
    const [papeis, setPapeis] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [inputUsuario, setInputUsuario] = useState('');
    const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

    useEffect(() => {
        setDados({
            ativo: true,
            ...formData,
        });
    }, [formData]);

    useEffect(() => {
        const carregarPapeis = async () => {
            try {
                // Ajuste aqui para a assinatura real da sua API
                const resultSituacoes = (await SituacaoAPI.situacoes?.(empresaTabelaId)) || [];
                const filtrado = (resultSituacoes || []).filter((item) => item.homologationPessoa === true);
                setPapeis(filtrado);
            } catch (error) {
                console.error(error);
            }
        };

        if (open) carregarPapeis();
    }, [open, empresaTabelaId]);

    useEffect(() => {
        const carregarUsuarios = async () => {
            try {
                if (!open) return;

                const result = await UsuarioAPI.datalist?.({
                    globalFilter: inputUsuario,
                });

                setUsuarios(result || []);
            } catch (error) {
                console.error(error);
                setUsuarios([]);
            }
        };

        carregarUsuarios();
    }, [open, inputUsuario, empresaId, empresaIds, empresaTabelaId, pessoaId]);

    function handleChange(e) {
        const { name, checked, type, value } = e.target;

        setDados((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    function handleOnBlur() {}
    function handleOnFocus() {}

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <>
                <DialogTitle>{dados?.uuid ? 'Editar Participante' : 'Novo Participante'}</DialogTitle>

                <DialogContent>
                    <div style={{ marginBottom: 16 }}>
                        <Autocomplete
                            options={Array.isArray(usuarios) ? usuarios : []}
                            value={usuarioSelecionado}
                            getOptionLabel={(option) => option?.descricao || ''}
                            onInputChange={(event, newInputValue) => {
                                setInputUsuario(newInputValue);
                            }}
                            onChange={(event, newValue) => {
                                setUsuarioSelecionado(newValue);

                                setDados((prev) => ({
                                    ...prev,
                                    pessoaId: newValue?.id || '',
                                }));
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Usuário" placeholder="Digite para buscar..." />
                            )}
                        />
                    </div>

                    <div>
                        <Select
                            text="Papel"
                            name="situacaoId"
                            options={papeis}
                            value={dados.situacaoId || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            isEnum={false}
                            notOptNull={false}
                        />

                        <Checkbox
                            text="Ativo"
                            name="ativo"
                            value={dados.ativo}
                            checked={!!dados.ativo}
                            handleOnChange={handleChange}
                        />
                    </div>

                    <div>
                        <Input
                            text="Data Entrada"
                            name="dataEntrada"
                            type="date"
                            inputWidth="180px"
                            value={dados.dataEntrada || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                        />

                        <Input
                            text="Data Saída"
                            name="dataSaida"
                            type="date"
                            inputWidth="180px"
                            value={dados.dataSaida || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                        />
                    </div>

                    <div>
                        <TextArea
                            text="Observação"
                            name="observacao"
                            value={dados.observacao || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            textAlign="left"
                            linhas="4"
                            colunas="100"
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="secondary" variant="contained">
                        Cancelar
                    </Button>
                    <Button onClick={() => onSave(dados)} color="success" variant="contained">
                        Salvar
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    );
}

export default HomologationPessoaDialog;
